export default function CustomerDiv({cname,company,address,mobile,email})
{
    return(
        <div>
            <span style={{fontSize:'12px',fontWeight:"bold",color:"#499aebff"}}>{cname}- {company}</span><br/>
            <span style={{fontSize:'11px',color:'#333333',display:address==""?"none":"block"}}><i className="fa fa-map-marker text-primary"></i> {address}</span><br/>
            <span style={{fontSize:'10px',color:'#333333'}}><i className="fa-solid fa fa-phone text-danger"></i> {mobile}</span>
            <span style={{fontSize:'10px',color:'#333333',display:email==""?"none":"block"}}><i className="fa-solid fa fa-envelope text-info"></i> {email}</span>            
        </div>
    );
}